import { ToggleGroup, ToggleGroupItem } from '@/components/shadcn/toggle-group'
import { cn } from '@/lib/utils'
import { Icon3By3GridOutline } from '@icons/Icon3By3GridOutline'
import { IconTableDataOutline } from '@icons/IconTableDataOutline'

export function GridTableToggle({
  value,
  onChange,
  className,
}: {
  value: 'cards' | 'table'
  onChange: (value: 'cards' | 'table') => void
  className?: string
}) {
  return (
    <ToggleGroup
      // variant="outline"
      className={cn('h-[35px] rounded-md border bg-background p-0.5', className)}
      type="single"
      value={value}
      onValueChange={(value) => onChange(value as 'cards' | 'table')}
    >
      <ToggleGroupItem className="h-[28px]" value="table">
        <IconTableDataOutline className="size-4" />
      </ToggleGroupItem>
      <ToggleGroupItem className="h-[28px]" value="cards">
        <Icon3By3GridOutline className="size-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  )
}
